<template>
    <ul :class="ulClass">
        <template v-for="(item, index) in items">
            <template v-if="item[groupProperty]">
                <Group
                    :key="`menu-${level}-group-${index}`"
                    :group="item"
                    :level="level+1"
                    :groupProperty="groupProperty"
                />
            </template>
            <template v-else>
                <Item
                    :key="`menu-${level}-item-${index}`"
                    :item="item"
                />
            </template>
        </template>
    </ul>
</template>

<script>

export default {
    mixins: [],
    components: {
        Group: () => import(/* webpackChunkName: "gestaomenu-group" */ './Group'),
        Item: () => import(/* webpackChunkName: "gestaomenu-item" */ './Item'),
    },
    props: {
        items: {
            type: Array,
            require: true,
        },
        level: {
            type: Number,
            default: 0,
        },
        groupProperty: {
            type: String,
            default: 'is_group',
        },
        ulClass: {
            type: String,
            default: 'nav nav-treeview',
        },
    },
    data() {
        return {

        }
    },
    methods: {

    },
}

</script>